import React from 'react';
import { Row } from 'react-bootstrap';
import { FormNumber, Fieldset } from '~/components/FormControl';

function Point() {
    return (
        <Fieldset className={'px-4'}>
            <Fieldset.Legend>Point:</Fieldset.Legend>
            <Row>
                <FormNumber
                    name="addonPoint"
                    sm={6}
                />
                <FormNumber
                    name="pointToSteal"
                    sm={6}
                />
            </Row>
        </Fieldset>
    );
}

export default Point;
